const themeColors = [
  {
    value: "light.blue",
    label: "Blue"
  },
  {
    value: "light.green",
    label: "Green"
  },
  {
    value: "light.greysteel",
    label: "Grey"
  },
  {
    value: "light.orange",
    label: "Orange"
  },
  {
    value: "light.purple",
    label: "Purple"
  },
  {
    value: "light.red",
    label: "Red"
  }
]

export default  themeColors
